<style scoped lang="scss">
  .page-employee-moveTaskStatistics {
    /deep/ .toolbars {
      .buttons {
        .mobile-group-button {
          padding-left: 9px;
          padding-right: 9px;
        }
      }
    }
    .rule-infos {
      display: flex;
      justify-content: flex-start;
      .totals {
        flex: 1;
        max-width: 100px;
      }
      .counts {
        flex: 2;
      }
    }
  }
</style>

<template>
  <div class="page-employee-moveTaskStatistics">
    <el-alert class="mrgb10" type="warning" :closable="false">
        <span slot="title">
            当前为员工管理的挪车统计，默认统计员工<span class="col_danger fwb">【所有工作过的服务区】</span>的挪车数据。
        </span>
    </el-alert>
    <div class="toolbars mrgb5">
        <div class="buttons mrgb5">
            <div class="fl">
              <el-button-group class="mrgr5 mrgb5">
                  <el-button :class="$root.isPc ? '' : 'mobile-group-button'" type="primary" v-for="(tab, index) in tabs" :plain="tabIndex !== index"
                      :key="'employee_tab_' + index" size="medium" @click="tabClick(index)">{{ tab }}</el-button>
              </el-button-group>
              <el-date-picker class="c-datetime-range mrgr5 mrgb5" v-model="selectedTime" type="datetimerange" size="medium" v-show="isShowSelectTime"
                    :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']" @change="_search"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    align="right">
                </el-date-picker>
            </div>
            <div class="fr">
                <span class="mrgr5 mrgb5">
                    <el-checkbox v-model="listQuery.isFilterArea" label="仅看当前服务区" border size="medium"
                        @change="serviceAreaChange"></el-checkbox>
                </span>
                <el-input class="c-el-input mrgr5 mrgb5" placeholder="员工的姓名/手机号" clearable v-model="listQuery.telOrName"
                    size="medium"></el-input>
                <el-button type="primary" size="medium" @click="_search()"><i class="fa fa-search"></i> 查询</el-button>
                <el-tooltip effect="dark" content="导出员工挪车统计数据" placement="top-start">
                  <el-button class="mrgb5" type="success" size="medium" @click="openExportEmployeesExcelLocal()"><i class="fa fa-sign-out"></i> 导出员工挪车统计</el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="按员工分别导出对应的挪车数据" placement="top-start">
                  <el-button class="mrgb5" type="warning" size="medium" @click="openExportExcels()"><i class="fa fa-sign-out"></i> 一键导出</el-button>
                </el-tooltip>
            </div>
            <div class="clearb"></div>
        </div>
    </div>
    <el-table :data="tableData" style="width: 100%" border size="medium">
      <el-table-column label="姓名" prop="name"></el-table-column>
      <el-table-column label="联系电话" prop="tel"></el-table-column>
      <el-table-column label="工作过的服务区" prop="workAreas" width="250">
        <template slot-scope="scope">
          <el-tag v-for="(item, index) in scope.row.workAreas" class="mrgb5 mrgr5" :key="index" type="info" effect="plain" size="small">
            【<span class="fwb">{{ item.platform || "" }}</span>】{{ item.name || "" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="挪车总量[条件达成量]" prop="totalTasks" min-width="300">
        <template slot-scope="scope">
            <div class="rule-infos">
              <div class="totals">
                <el-tag type="primary" size="small" @click="navTo(scope.row)">{{ scope.row.totalTasks }}</el-tag>
              </div>
              <div class="counts">
                <el-tag type="info" size="small" class="mrgb5 mrgr5" effect="plain"
                  v-for="(item, index) in scope.row.ruleCounts" :key="index">
                    {{ item.ruleDesc }}：
                    <span class="mrgr5 col_danger">{{ item.count }}</span>
                    <span class="col_info">({{ item.rate }}%)</span>
                </el-tag>
              </div>
            </div>
        </template>
      </el-table-column>
      <el-table-column label="[组合判定]有效挪车量/占比" prop="effectiveTasks">
        <template slot="header">
          <span>
            有效挪车量/占比
            <el-tooltip effect="dark" content="有效挪车量：满足所有条件判定规则，组合判断为有效的挪车量。" placement="top-start">
              <i class="el-icon-warning-outline col_warning"></i>
            </el-tooltip>
          </span>
        </template>
        <template slot-scope="scope">
            <el-tag type="success" size="small" @click="navTo(scope.row, 1)">
              {{ scope.row.effectiveTasks }}
            </el-tag>
            <el-tag class="mrgl5" type="info" effect="plain" size="small" @click="navTo(scope.row, 1)">
              {{ scope.row.effective_rate }}%
            </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="[组合判定]无效挪车量/占比" prop="invalidTasks">
        <template slot="header">
          <span>
            无效挪车量/占比
            <el-tooltip effect="dark" content="无效挪车量：满足所有条件判定规则，组合判断为无效的挪车量。" placement="top-start">
              <i class="el-icon-warning-outline col_warning"></i>
            </el-tooltip>
          </span>
        </template>
        <template slot-scope="scope">
            <el-tag type="danger" size="small" @click="navTo(scope.row, 0)">
              {{ scope.row.invalidTasks }}
            </el-tag>
            <el-tag class="mrgl5" type="info" effect="plain" size="small" @click="navTo(scope.row, 0)">
              {{ scope.row.invalid_rate }}%
            </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="重复挪车数量">
        <template slot="header">
          <span>
            重复挪车数量
            <el-tooltip effect="dark" content="同人同天同车≥2次，多出次数的按天累加总和" placement="top-start">
              <i class="el-icon-warning-outline col_warning"></i>
            </el-tooltip>
          </span>
        </template>
        <template slot-scope="scope">
            <el-tag :type="scope.row.repeatMoveCount > 0 ? 'danger' : 'info'" size="small" @click="openRepeatDetail(scope.row)">
              {{ scope.row.repeatMoveCount }}
            </el-tag>
            <template v-if="scope.row.repeatMoveCount > 0">
              <el-tag class="mrgl5" type="info" effect="plain" size="small" @click="openRepeatDetail(scope.row)">{{ getRepeatRate(scope.row) }}%</el-tag>
            </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160" fixed="right">
        <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="navTo(scope.row)">详情</el-button>
            <el-tooltip effect="dark" :content="scope.row.name + '的挪车数据'" placement="left">
              <el-button type="warning" plain size="mini" @click="openExportExcel(scope.row)">导出</el-button>
            </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 重复挪车明细抽屉 -->
    <el-drawer
      title="重复挪车明细"
      :visible.sync="repeatDetailVisible"
      direction="rtl"
      size="45%">
      <div v-if="repeatDetailRow" style="padding: 0 20px; display: flex; flex-direction: column; max-height: calc(100vh - 80px);">
        <div style="margin-bottom: 16px; padding-bottom: 12px; border-bottom: 2px solid #409EFF;">
          <span style="font-size: 16px; font-weight: bold; color: #303133;">
            {{ repeatDetailRow.name }}
          </span>
          <span style="font-size: 14px; color: #909399; margin-left: 8px;">{{ repeatDetailRow.tel }}</span>
        </div>
        <div style="margin-bottom: 14px; padding: 10px 14px; background: #ECF5FF; border-radius: 4px; color: #606266; font-size: 13px;">
          <i class="fa fa-info-circle" style="color: #409EFF; margin-right: 4px;"></i>
          共 <b>{{ repeatDetailRow.repeatDetails.length }}</b> 条记录，<b>{{ getRepeatCarCount(repeatDetailRow) }}</b> 辆车，重复挪车次数合计：<b style="color: #F56C6C;">{{ repeatDetailRow.repeatMoveCount }}</b>
        </div>
        <div style="flex: 1; overflow-y: auto;">
        <div v-for="(item, idx) in repeatDetailRow.repeatDetails" :key="'rd_' + idx"
          style="display: flex; align-items: center; padding: 10px 14px; margin-bottom: 6px; border-radius: 4px; background: #fff; border: 1px solid #EBEEF5; font-size: 13px;">
          <span style="color: #606266; min-width: 110px;">{{ formatDate(item.date) }}</span>
          <i class="fa fa-motorcycle" style="font-size: 16px; color: #409EFF; margin: 0 6px;"></i>
          <span style="font-weight: 500; color: #303133; min-width: 120px;">{{ item.carId }}</span>
          <span style="color: #909399; margin-left: 8px;">挪<span style="color: #303133; font-weight: 500;">{{ item.totalCount }}</span>次</span>
          <el-tag size="mini" effect="plain" type="warning" style="margin-left: 12px;">重复{{ item.repeatCount }}次</el-tag>
          <el-button type="text" size="mini" style="margin-left: auto; color: #409EFF;" @click="navToRepeatCarByDate(item)">查看</el-button>
        </div>
        </div>
      </div>
    </el-drawer>

    <!--导出excel-->
    <export-to-excel :ref="refExportToExcel"></export-to-excel>
    <!-- 挪车详情弹窗 -->
    <el-dialog :title="moveDataTitle" :fullscreen="true"
      :visible.sync="moveDataVisible" :before-close="_close" :close-on-click-modal="false">
      <move-data :ref="refMoveData"></move-data>
    </el-dialog>
  </div>
</template>

<script>
  import permission from "@/mixins/permission"
  import * as funEmployees from '@/api/employees'
  import moment from "moment"
  import ExportToExcel from "@/components/Excels/JsonToExcel"
  import { AnalysisMoveStatistics, AnalysisMoveTask } from "@/mixins/commonPageExport"
  import MoveData from "./moveData"
  export default {
    name: "pageEmployeeMoveStatistics",
    mixins: [permission],
    components: { ExportToExcel, MoveData },
    data() {
      let that = this
      return {
        refExportToExcel: "refEmployeeToMoveStatistics",
        refMoveData: "refEmployeeToMoveData",
        tableData: [],
        defaultQueryParams: {
          platform: "",
          area: "",
          telOrName: "",
          keywords: "",
          beginDate: "",
          endDate: "",
          beginTime: "",
          endTime: "",
          flag: null,
          startParkId: "",
          endParkId: "",
          isAudited: null,
          auditFlag: null,
          isFilterArea: false
        },
        listQuery: {},
        selectedTime: [moment().startOf("month").format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD 23:59:59")],
        pickerOptions: {
            shortcuts: [
                { text: "昨天", onClick: (picker) => { let timeArr = that.setPickerTime(picker, 1, "days"); that.setQueryTime(timeArr) }},
                { text: "近一周", onClick: (picker) => { let timeArr = that.setPickerTime(picker, 1, "weeks"); that.setQueryTime(timeArr) }},
                { text: "近一月", onClick(picker) { let timeArr = that.setPickerTime(picker, 1, "months"); that.setQueryTime(timeArr) }},
                { text: "近三月", onClick(picker) { let timeArr = that.setPickerTime(picker, 3, "months"); that.setQueryTime(timeArr) }},
                { text: "近半年", onClick(picker) { let timeArr = that.setPickerTime(picker, 6, "months"); that.setQueryTime(timeArr) }},
                { text: "近一年", onClick(picker) { let timeArr = that.setPickerTime(picker, 1, "years"); that.setQueryTime(timeArr) }}
            ]
        },
        tabIndex: 0,
        tabs: ["昨日", "本月", "上月", "自定义"],
        isShowSelectTime: false,
        moveDataVisible: false,
        moveDataTitle: "",
        repeatDetailVisible: false,
        repeatDetailRow: null
      }
    },
    watch: {
        "$store.getters.serviceArea"(v) {
            this.mxIsSameActiveTabWithRoute(() => {
                this.serviceAreaChange(this.listQuery.isFilterArea)
            })
        }
    },
    mounted() {
      this.open()
    },
    methods: {
      open() {
        this.listQuery = { ...this.defaultQueryParams }
        this.tabClick(0)
      },
      setPickerTime(picker, spaceTime, dateStr, isStartOf) {
          let timeArr = []
          let startTime = null
          let endTime = moment().subtract(1, "d").format("YYYY-MM-DD 23:59:59")
          startTime = moment().subtract(spaceTime, dateStr).format("YYYY-MM-DD 00:00:00")
          startTime = moment(startTime).format("YYYY-MM-DD 00:00:00")
          timeArr = [startTime, endTime]
          if (picker) picker.$emit('pick', timeArr);
          return timeArr
      },
      setQueryTime(timeArr) {
          this.listQuery.beginDate = timeArr[0] || ""
          this.listQuery.endDate = timeArr[1] || ""
      },
      setSelectedTime() {
          let psTime = "", peTime = ""
          if (this.selectedTime && this.selectedTime[0] && moment(this.selectedTime[0]).isValid())
              psTime = moment(this.selectedTime[0]).format("YYYY-MM-DD HH:mm:ss")
          if (this.selectedTime && this.selectedTime[1] && moment(this.selectedTime[1]).isValid())
              peTime = moment(this.selectedTime[1]).format("YYYY-MM-DD HH:mm:ss")
          this.listQuery.beginDate = psTime
          this.listQuery.endDate = peTime
          this.selectedTime = [this.listQuery.beginDate, this.listQuery.endDate]
      },
      async getListData() {
        this.setSelectedTime()
        window.$common.fullLoading()
        await funEmployees.GetEmployeeMoveTaskStatistics(this.listQuery).then(response => {
          window.$common.closeFullLoading()
          this.tableData = response.map(x => {
            x.workAreas = []
            x.effective_rate = window.$util.toFixed(x.effectiveTasks / (x.totalTasks || 1) * 100)
            x.invalid_rate = window.$util.toFixed(x.invalidTasks / (x.totalTasks || 1) * 100)
            x.ruleCounts = x.ruleCounts.map(y => {
                y.rate = window.$util.toFixed(y.count / (x.totalTasks || 1) * 100)
                return y
            })
            return x
          })
        })
        await this.getWorkAreasData()
      },
      async getWorkAreasData() {
        try {
          let tableData = [...this.tableData]
          for (let index = 0; index < tableData.length; index++) {
            const item = tableData[index];
            let params = { telOrName: item.tel, beginDate: this.listQuery.beginDate, endDate: this.listQuery.endDate }
            const response = await funEmployees.GetEmployeeMoveTaskArea(params);
            if (Array.isArray(response)) {
              tableData[index].workAreas = response.map(x => x?.areaInfo) || [];
            } else {
              tableData[index].workAreas = [];
            }
          }
          this.tableData = [...tableData]
        } catch (error) {
          console.error('获取工作服务区数据失败:', error);
          this.errorMsg('获取工作服务区失败，请刷新重试');
        }
      },
      serviceAreaChange(val) {
        if (val === true) {
            this.listQuery.platform = this.$store.getters.servicePlatform || ""
            this.listQuery.area = this.$store.getters.serviceArea || ""
        } else {
            this.listQuery.platform = ""
            this.listQuery.area = ""
        }
        this._search()
      },
      tabClick(index) {
        this.tabIndex = index
        switch(index) {
          case 0: {
            let endTime = moment().subtract(1, "d").format("YYYY-MM-DD 23:59:59")
            this.selectedTime = [moment(endTime).format("YYYY-MM-DD 00:00:00"), endTime]
            break
          }
          case 1: {
            this.selectedTime = [moment().startOf("month").format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD 23:59:59")]
            break
          }
          case 2: {
            this.selectedTime = [moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD 00:00:00"), moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD 23:59:59")]
            break
          }
        }
        if (index !== 3) { this.isShowSelectTime = false; this._search() }
        else { this.selectedTime = []; this.isShowSelectTime = true; this.tableData = [] }
      },
      navTo(item, type) {
        this.moveDataTitle = `【${item.name} | ${item.tel}】的挪车记录`
        this.moveDataVisible = true
        setTimeout(() => {
          this.$refs[this.refMoveData].open({
            isFilterArea: this.listQuery.isFilterArea,
            telOrName: item.tel,
            selectedTime: this.selectedTime,
            type,
            tabIndex: this.tabIndex
          })
        }, 100)
      },
      _search() { this.listQuery.page = 1; this.getListData() },
      _close() {
        this.$refs[this.refMoveData].close()
        this.moveDataVisible = false
      },
      openRepeatDetail(row) {
        if (!row.repeatDetails || row.repeatDetails.length === 0) {
          this.infoMsg("该员工没有重复挪车记录")
          return
        }
        this.repeatDetailRow = row
        this.repeatDetailVisible = true
      },
      // 查看重复明细中某天某车的详情
      navToRepeatCarByDate(item) {
        const day = moment(item.date).format("YYYY-MM-DD")
        const selectedTime = [day + " 00:00:00", day + " 23:59:59"]
        this.moveDataTitle = `【${this.repeatDetailRow.name} | ${item.carId} | ${day}】重复挪车记录`
        this.moveDataVisible = true
        setTimeout(() => {
          this.$refs[this.refMoveData].open({
            isFilterArea: this.listQuery.isFilterArea,
            telOrName: this.repeatDetailRow.tel,
            keyword: item.carId,
            selectedTime: selectedTime,
            tabIndex: 3
          })
        }, 100)
      },
      getRepeatCarCount(row) {
        if (!row.repeatDetails) return 0
        return new Set(row.repeatDetails.map(d => d.carId)).size
      },
      getRepeatRate(row) {
        if (!row.totalTasks || row.totalTasks === 0) return 0
        return window.$util.toFixed(row.repeatMoveCount / row.totalTasks * 100)
      },
      formatDate(dateStr) {
        if (!dateStr) return ""
        return moment(dateStr).format("YYYY-MM-DD")
      },
      openExportEmployeesExcelLocal() {
        if (this.total > this.maxExportCount) { this.warningMsg("不允许导出超过2万条数据，如有需要，请联系管理员处理!"); return false }
        else if (this.total <= 0) { this.warningMsg("没有需要导出的数据!"); return false }
        let tableDatas = this.tableData.map(x => {
          x.workAreaDesc = x.workAreas.map(y => `【${y.platform}】${y.name}`).join(",")
          return x
        })
        let exportData = ""
        if (this.listQuery.beginDate && this.listQuery.endDate) {
          let sbtd = moment(this.listQuery.beginDate).format("YYYY-MM-DD")
          let ebtd = moment(this.listQuery.endDate).format("YYYY-MM-DD")
          exportData = sbtd == ebtd ? sbtd : `${sbtd}至${ebtd}`
        } else { exportData = "全部" }
        let exportName = `${this.listQuery.area || ""}员工挪车统计(${exportData}).xlsx`
        AnalysisMoveStatistics(exportName, tableDatas)
      },
      openExportEmployeesExcel() {
        if (this.total > this.maxExportCount) { this.warningMsg("不允许导出超过2万条数据，如有需要，请联系管理员处理!"); return false }
        let searchs = JSON.parse(JSON.stringify(this.listQuery)); searchs.page = 1; searchs.size = this.maxExportCount
        window.$common.fullLoading()
        funEmployees.GetEmployeeMoveTaskStatistics(searchs).then(res => {
          if (res && res.length > 0) {
              let tableDatas = res.map(x => {
                x.effective_rate = window.$util.toFixed(x.effectiveTasks / (x.totalTasks || 1) * 100) + "%"
                x.invalid_rate = window.$util.toFixed(x.invalidTasks / (x.totalTasks || 1) * 100) + "%"
                x.ruleCounts = x.ruleCounts.map(y => { y.rate = window.$util.toFixed(y.count / (x.totalTasks || 1) * 100) + "%"; return y })
                return x
              })
              let exportData = ""
              if (searchs.beginDate && searchs.endDate) {
                let sbtd = moment(searchs.beginDate).format("YYYY-MM-DD"); let ebtd = moment(searchs.endDate).format("YYYY-MM-DD")
                exportData = sbtd == ebtd ? sbtd : `${sbtd}至${ebtd}`
              } else { exportData = "全部" }
              let exportName = `${this.listQuery.area || ""}员工挪车统计(${exportData}).xlsx`
              AnalysisMoveStatistics(exportName, tableDatas)
          } else {
              window.$common.closeFullLoading()
              setTimeout(() => { this.alert("没有需要导出的数据!") }, 10)
          }
        }).catch(() => { console.log("export error") })
      },
      openExportExcels() {
        try {
            window.$common.fullLoading()
            for (let i in this.tableData) {
                ((i) => {
                    setTimeout(() => {
                        this.openExportExcel(this.tableData[i])
                        if (i >= this.tableData.length - 1) window.$common.closeFullLoading()
                    }, (i + 1) * 50);
                })(i)
            }
        } catch(e) { this.alert("导出数据格式不正确!"); return false }
      },
      openExportExcel(row) {
        if (this.total > this.maxExportCount) { this.warningMsg("不允许导出超过2万条数据，如有需要，请联系管理员处理!"); return false }
        let searchs = JSON.parse(JSON.stringify(this.listQuery)); searchs.page = 1; searchs.size = this.maxExportCount
        if (row && row.tel) searchs.telOrName = row.tel
        window.$common.fullLoading()
        funEmployees.GetEmployeeMoveTasks(searchs).then(res => {
            if (res && res.items && res.items.length > 0) {
                let tableDatas = res.items.map(x => {
                    x.start_time = this.getFormatDate(x.start_time)
                    x.end_time = this.getFormatDate(x.end_time)
                    x.first_order_time = this.getFormatDate(x.first_order_time)
                    return x
                })
                let exportData = ""
                if (searchs.beginDate && searchs.endDate) {
                  let sbtd = moment(searchs.beginDate).format("YYYY-MM-DD"); let ebtd = moment(searchs.endDate).format("YYYY-MM-DD")
                  exportData = sbtd == ebtd ? sbtd : `${sbtd}至${ebtd}`
                } else { exportData = "全部" }
                let exportName = `${this.listQuery.area || ""}${row && row.name || '员工'}的挪车数据(${exportData}).xlsx`
                AnalysisMoveTask(exportName, tableDatas)
            } else {
                window.$common.closeFullLoading()
                setTimeout(() => { this.alert("没有需要导出的数据!") }, 10)
            }
        }).catch((ex) => { console.log("export error: ", ex) })
      }
    }
  }
</script>
